import {
  Button,
  Card,
  Chip,
  Container,
  Grid2,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";

import { gql } from "@apollo/client";
import { UserRolesQuery, useUserRolesQuery } from "~/graphql/__generated__/graphql";
import EditRoleDialog, { usePermissionOptions } from "./EditRoleDialog";
import { sortBy } from "lodash";

type Role = UserRolesQuery["userRole"][number]

const TabRoles = () => {
  const { data } = useUserRolesQuery();

  const [editingRole, setEditingRole] = useState<Role | null>(null);
  const permissionOptions = usePermissionOptions();

  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Card>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Role</TableCell>
              <TableCell>Permissions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!data && <TableRow>
              <TableCell><Skeleton width="100%" /></TableCell>
              <TableCell><Skeleton width="100%" /></TableCell>
            </TableRow>}
            {sortBy(data?.userRole, r => 100 - r.permissions.length).map(role => <TableRow key={role.id}>
                <TableCell sx={{ minWidth: 180 }}>
                  {role.name}
                  <IconButton size="small" onClick={() => setEditingRole(role)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <Grid2 container spacing={1}>
                    {permissionOptions.map(o => role.permissions.includes(o.p) && <Tooltip
                      key={o.key}
                      title={o.help}
                    >
                      <Chip label={o.label} />
                    </Tooltip>)}
                  </Grid2>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell colSpan={3}>
                <Button
                  onClick={() => setEditingRole({ id: 0, name: "", permissions: [] })}
                  size="small"
                  startIcon={<AddCircleOutlineIcon fontSize="small" />}
                >
                  Add New Role
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>

      {editingRole && (
        <EditRoleDialog
          onClose={() => setEditingRole(null)}
          role={editingRole}
        />
      )}
    </Container>
  );
};

export default TabRoles;



gql(`
  query UserRoles
  @permission(requires: manageOrgConfig)
  {
    userRole {
      id
      name
      permissions
    }
  }
`);
